module.exports = __webpack_public_path__ + "d93039ede952f839b256b4edbd43867b.svg";